import { login, logout } from '@/api/login'
import { getUserInfo } from '@/api/adminUser'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user: {},
    role: '',
    menus: {},
    loaded: true
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_LOADED: (state, loaded) => {
      state.loaded = loaded
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        login(userInfo.username, userInfo.password, userInfo.code, userInfo.uuid).then(res => {
          // 用户登录完成，设置Token
          setToken(res.data.token, rememberMe)
          commit('SET_TOKEN', res.data.token)

          // 第一次加载用户信息（用户详情、角色、权限、菜单）时用到， 具体见 src 目录下的 permission.js
          commit('SET_LOADED', false)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          setUserInfo(res, commit)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          logOut(commit)
          resolve()
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    },

    updateLoaded({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADED', true)
      })
    }
  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLE', '')
  removeToken()
}

export const setUserInfo = (res, commit) => {
  commit('SET_USER', res.data.user)
  commit('SET_ROLE', res.data.role)
  commit('SET_MENUS', res.data.menus)
  commit('SET_PERMISSIONS', res.data.permissions)
}

export default user
